export const Role = {
    Guest: 0,
    Developer: 3,
    Administrator: 7
};